import { RouteObject } from 'react-router-dom'
import { lazy } from 'react'
import ModuleGuard from '@/core/guards/ModuleGuard.tsx'
import ErrorPage from '@/pages/errors/ErrorPage.tsx'

const SUPPORT_ROUTES: RouteObject[] = [
  {
    path: 'support',
    element: <ModuleGuard />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: 'release-request',
        lazy: async () => {
          const ReleaseRequestPage = lazy(
            () => import('@/pages/requests/ReleaseRequestPage')
          )
          return { element: <ReleaseRequestPage /> }
        }
      },
      {
        path: 'release-request/:id/details',
        lazy: async () => {
          const RequestDetailsPage = lazy(
            () => import('@/pages/requestsDetails/RequestDetailsPage.tsx')
          )
          return { element: <RequestDetailsPage /> }
        }
      },
      {
        path: 'client-edit-request',
        lazy: async () => {
          const ClientEditRequestPage = lazy(
            () => import('@/pages/requests/ClientEditRequestPage.tsx')
          )
          return { element: <ClientEditRequestPage /> }
        }
      },
      {
        path: 'client-edit-request/:id/details',
        lazy: async () => {
          const RequestDetailsPage = lazy(
            () => import('@/pages/requestsDetails/RequestDetailsPage.tsx')
          )
          return { element: <RequestDetailsPage /> }
        }
      },
      {
        path: 'article-edit-request',
        lazy: async () => {
          const ArticleEditRequestPage = lazy(
            () => import('@/pages/requests/ArticleEditRequestPage.tsx')
          )
          return { element: <ArticleEditRequestPage /> }
        }
      },
      {
        path: 'article-edit-request/:id/details',
        lazy: async () => {
          const RequestDetailsPage = lazy(
            () => import('@/pages/requestsDetails/RequestDetailsPage.tsx')
          )
          return { element: <RequestDetailsPage /> }
        }
      },
      {
        path: 'article-change-request',
        lazy: async () => {
          const ArticleChangeRequestPage = lazy(
            () => import('@/pages/requests/ArticleChangeRequestPage.tsx')
          )
          return { element: <ArticleChangeRequestPage /> }
        }
      },
      {
        path: 'article-change-request/:id/details',
        lazy: async () => {
          const RequestDetailsPage = lazy(
            () => import('@/pages/requestsDetails/RequestDetailsPage.tsx')
          )
          return { element: <RequestDetailsPage /> }
        }
      },
      {
        path: 'article-reassign-request',
        lazy: async () => {
          const ArticleReassignRequestPage = lazy(
            () => import('@/pages/requests/ArticleReassignRequestPage.tsx')
          )
          return { element: <ArticleReassignRequestPage /> }
        }
      },
      {
        path: 'article-reassign-request/:id/details',
        lazy: async () => {
          const RequestDetailsPage = lazy(
            () => import('@/pages/requestsDetails/RequestDetailsPage.tsx')
          )
          return { element: <RequestDetailsPage /> }
        }
      },
      {
        path: 'article-delete-request',
        lazy: async () => {
          const ArticleDeleteRequestPage = lazy(
            () => import('@/pages/requests/ArticleDeleteRequestPage.tsx')
          )
          return { element: <ArticleDeleteRequestPage /> }
        }
      },
      {
        path: 'article-delete-request/:id/details',
        lazy: async () => {
          const RequestDetailsPage = lazy(
            () => import('@/pages/requestsDetails/RequestDetailsPage.tsx')
          )
          return { element: <RequestDetailsPage /> }
        }
      }
    ]
  }
]

export default SUPPORT_ROUTES
